import { Mail, Phone, MessageCircle } from "lucide-react";
import { SITE, WHATSAPP_URL } from "@/config/site";
import { LegalModal } from "@/components/landing/Legal";
import { trackEvent, EVENTS } from "@/utils/track";

const NAV = [
  { label: "Inicio", href: "#inicio" },
  { label: "El problema", href: "#problema" },
  { label: "La solución", href: "#solucion" },
  { label: "Cómo funciona", href: "#como-funciona" },
  { label: "FAQ", href: "#faq" },
  { label: "Blog", href: "/blog" },
  { label: "Contacto", href: "#auditoria" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-navy">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#inicio" data-testid="footer-logo" className="inline-flex items-center">
              <img src="/logo-horizontal-white.png" alt={SITE.name} className="h-6 w-auto" />
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#9FB8D8]">
              {SITE.tagline}
            </p>
          </div>

          <nav aria-label="Enlaces del pie de página">
            <p className="text-xs font-bold uppercase tracking-widest text-[#9FB8D8]">
              Navegación
            </p>
            <ul className="mt-4 space-y-3">
              {NAV.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="inline-block py-1 text-sm text-[#C3D2E6] transition-colors duration-200 hover:text-white"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-[#9FB8D8]">
              Legal y contacto
            </p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <LegalModal
                  type="privacidad"
                  testId="footer-link-privacidad"
                  trigger={
                    <button type="button" className="inline-block py-1 text-[#C3D2E6] transition-colors duration-200 hover:text-white">
                      Política de privacidad
                    </button>
                  }
                />
              </li>
              <li>
                <LegalModal
                  type="aviso"
                  testId="footer-link-aviso"
                  trigger={
                    <button type="button" className="inline-block py-1 text-[#C3D2E6] transition-colors duration-200 hover:text-white">
                      Aviso legal
                    </button>
                  }
                />
              </li>
              <li>
                <LegalModal
                  type="cookies"
                  testId="footer-link-cookies"
                  trigger={
                    <button type="button" className="inline-block py-1 text-[#C3D2E6] transition-colors duration-200 hover:text-white">
                      Cookies
                    </button>
                  }
                />
              </li>
            </ul>
            <ul className="mt-6 space-y-3 text-sm">
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email-link"
                  className="inline-flex items-center gap-2 py-1 text-[#C3D2E6] transition-colors duration-200 hover:text-white"
                >
                  <Mail className="h-4 w-4 shrink-0" />
                  {SITE.email}
                </a>
              </li>
              <li>
                <a
                  href={SITE.phoneHref}
                  data-testid="footer-phone-link"
                  className="inline-flex items-center gap-2 py-1 text-[#C3D2E6] transition-colors duration-200 hover:text-white"
                >
                  <Phone className="h-4 w-4 shrink-0" />
                  {SITE.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="inline-flex items-center gap-2 py-1 text-[#C3D2E6] transition-colors duration-200 hover:text-white"
                  onClick={() => trackEvent(EVENTS.WHATSAPP_CLICK, { ubicacion: "footer" })}
                >
                  <MessageCircle className="h-4 w-4 shrink-0" />
                  WhatsApp: {SITE.phoneDisplay}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-7 text-center text-xs text-[#9FB8D8]">
          © {new Date().getFullYear()} {SITE.name}. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
